export const SESSION = {
  ENTRY_SOURCE_KEY: 'entrySource',
  BACK_GUARD_KEY: 'backGuardUsed',
};
